/**
 * 바이트를 사람이 읽기 쉬운 형태로 포맷팅합니다.
 * @param bytes - 포맷팅할 바이트 수
 * @param isWithUnit - 단위를 포함할지 여부 (기본값: false)
 * @returns 포맷팅된 문자열 (예: "1.5 GB" 또는 "1.5")
 */
export const formatBytes = (bytes: number, isWithUnit: boolean = false): string => {
  if (bytes === 0) return '0.0 MB';

  const k = 1024;
  const mb = bytes / Math.pow(k, 2);
  const gb = bytes / Math.pow(k, 3);

  if (gb >= 1) {
    const formatted = gb.toFixed(1);
    return formatted + (isWithUnit ? ' GB' : '');
  } else {
    const formatted = mb.toFixed(1);
    return formatted + (isWithUnit ? ' MB' : '');
  }
};
